/**
 * AppStoreLinker - Handles deep linking to mobile apps and app stores
 *
 * Generates appropriate URLs for:
 * - iOS App Store
 * - Android Play Store
 * - Deep links to installed apps
 */
export class AppStoreLinker {
  constructor(config = {}) {
    this.iosAppId = config.iosAppId || '1454535568';
    this.androidPackageName = config.androidPackageName || 'com.grailify.grailify';
    this.appScheme = config.appScheme || 'grailify';
  }

  /**
   * Get the appropriate store URL based on device
   * @param {DeviceDetector} deviceDetector
   * @returns {string}
   */
  getStoreUrl(deviceDetector) {
    if (deviceDetector.isIOS()) {
      return this.getIOSStoreUrl();
    } else if (deviceDetector.isAndroid()) {
      return this.getAndroidStoreUrl();
    }
    return '#';
  }

  /**
   * Get iOS App Store URL
   * @returns {string}
   */
  getIOSStoreUrl() {
    return `https://apps.apple.com/gb/app/grailify-sneaker-releases/id${this.iosAppId}`;
  }

  /**
   * Get Android Play Store URL
   * @returns {string}
   */
  getAndroidStoreUrl() {
    return `https://play.google.com/store/apps/details?id=${this.androidPackageName}`;
  }

  /**
   * Get Android Intent URL with fallback to Play Store
   * @param {string} path - App path to deep link to
   * @returns {string}
   */
  getAndroidIntentUrl(path = '') {
    const playStoreUrl = this.getAndroidStoreUrl();
    return `intent://${path}#Intent;scheme=${this.appScheme};package=${this.androidPackageName};S.browser_fallback_url=${encodeURIComponent(playStoreUrl)};end`;
  }

  /**
   * Get deep link URL for opening the app
   * @param {string} path - App path to deep link to
   * @returns {string}
   */
  getDeepLinkUrl(path = '') {
    return `${this.appScheme}://${path}`;
  }
}

// Default instance with Grailify config
export const appStoreLinker = new AppStoreLinker();
